import React, { useCallback } from 'react';
//interface
import { QuantityProps } from './interface';
//patterns
import { onlyNumbers } from 'pages/Quotes/utils/patterns';
//components
import { Visibility } from 'components/Visibility';
import Input from "pages/Quotes/components/generics/Input/Input";

export const Quantity: React.FC<QuantityProps> = (props) => {
  const {
    quantity,
    multiple,
    isEditing,
    unitPrice,
    openTooltip,
    setQuantity,
    readOnly = false,
    validateConversionQt,
    tooltipText
  } = props;

  const handleQuantity = (text: string) => {
    const quantityValidated = validateConversionQt(text, 1, true);
    if (quantityValidated !== quantity) setQuantity(quantityValidated);
  };

  const validateMultiple = useCallback(() => {
    let validateQuantity = validateConversionQt(String(quantity), multiple, true);

    if (validateQuantity !== null && validateQuantity % multiple !== 0) {
      if (multiple > 1) {
        if (validateQuantity < multiple)
          validateQuantity = multiple;
        else
          validateQuantity = Math.floor(validateQuantity / multiple) * multiple;
      }
    }

    handleQuantity(String(validateQuantity));
  }, [quantity, multiple, unitPrice, openTooltip]);

  const inputIsValid = true ? !openTooltip.quantity : false;
  const valueInput = quantity == null || quantity == undefined ? "0" : String(quantity);

  return (
    <div className="headerQuoteItem quantityQuoteItem">
      <span className="subtitle">Quantidade</span>
      <div className="value flex-column" style={{ alignItems: "baseline" }}>
        {!isEditing ? (
          <div className="value">{Number(quantity)} </div>
        ) : (
          <Input
            alt="inputQuantity"
            width="89px"
            setIsValid={() => { }}
            isValid={inputIsValid}
            value={valueInput}
            readOnly={readOnly}
            onChange={(text: string) => handleQuantity(text)}
            onBlur={validateMultiple}
            type="number"
            pattern={onlyNumbers}
            tooltipText={tooltipText}
          />
        )}
        <Visibility visible={openTooltip.quantity && multiple > 1}>
          <span className="quantityMultiple">Múltiplo: {multiple}</span>
        </Visibility>
      </div>
    </div>
  );
};